import Divider from '@mui/material/Divider'
import Diagram from './Diagram'
import Grid from '@mui/material/Grid'

interface Props {
  left: React.ReactNode
  middle?: React.ReactNode
  right: React.ReactNode
}

export default function DiagramFrame({ left, middle, right }: Props) {
  return (
    <Grid container direction="row" spacing={2}>
      <Grid
        size={4.5}
        sx={{
          paddingTop: { sx: 0, sm: 3 },
          paddingBottom: 3,
          gap: 2
        }}>
        <Diagram>{left}</Diagram>
      </Grid>
      <Grid
        size={3}
        container
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          paddingY: 1
        }}>
        {middle || <Divider orientation="vertical" sx={{ borderColor: 'contrast.low', borderStyle: 'dashed' }} />}
      </Grid>
      <Grid
        size={4.5}
        sx={{
          paddingTop: { sx: 0, sm: 3 },
          paddingBottom: 3
        }}>
        <Diagram>{right}</Diagram>
      </Grid>
    </Grid>
  )
}
